import { gql } from '@apollo/client';

export const GET_SCHOOLDETAIL = gql`
  query SkWeb_School_4($schoolId: ID!) {
    school(schoolId: $schoolId) {
      name
      numberOfTeachers
      numberOfStudents
      products {
        id
        name
      }
      teachers {
        id
        products {
          id
          name
        }
      }
      students {
        products {
          id
          name
        }
      }
      classrooms {
        name
        studentsLength
        teacherLength
        highScore
        mediumScore
        lowScore
        courses {
          product {
            id
            name
          }
          level
        }
      }
    }
  }
`;
